import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';

import {
  convertToDollars,
  convertToPercentage,
  epochToDateInReadableFormat,
} from '../../../../../../utils';
import { CONTRACT_TYPES } from '../../../../../contracts/constants';

/**
 * Transforms contract data from API format to display format
 * @param {Object} contract - The contract object from the API
 * @returns {Object} Transformed contract data for display
 */
export const transformContractData = (contract) => {
  if (!contract) return {};

  const contractScope = contract.contractScope || {};
  const rates = contract.rates || {};
  const fixedRates = rates?.fixedRates || {};
  const marginRates = rates?.marginRates || {};
  const timeWindow = contract?.timeWindow || {};
  const corporationName = contractScope?.corporation?.name || 'N/A';
  const agencyName = contractScope?.agency?.name || 'N/A';
  const stipend = contract?.stipend;

  // Format start date from timeWindow.start
  const startDate = timeWindow?.start ? epochToDateInReadableFormat(timeWindow.start) : 'N/A';

  // Format end date from timeWindow.end
  const endDate = timeWindow?.end ? epochToDateInReadableFormat(timeWindow.end) : 'N/A';

  // Format pay rate
  const payRate = fixedRates.pay?.reg
    ? LanguageConverterV2('contractCard.rateFormat', {
        amount: convertToDollars(fixedRates.pay.reg, 2),
      })
    : 'N/A';

  // Format OT pay rate
  const oTPayRate = fixedRates.pay?.OT
    ? LanguageConverterV2('contractCard.rateFormat', {
        amount: convertToDollars(fixedRates.pay.OT, 2),
      })
    : 'N/A';

  // Format bill rate
  const billRate = fixedRates.bill?.reg
    ? LanguageConverterV2('contractCard.rateFormat', {
        amount: convertToDollars(fixedRates.bill.reg, 2),
      })
    : 'N/A';

  // Format OT bill rate
  const oTBillRate = fixedRates.bill?.OT
    ? LanguageConverterV2('contractCard.rateFormat', {
        amount: convertToDollars(fixedRates.bill.OT, 2),
      })
    : 'N/A';

  // Format pay margin
  const payMargin = marginRates.reg ? convertToPercentage(marginRates.reg, 0) : 'N/A';

  // Format OT pay margin
  const oTPayMargin = marginRates.OT ? convertToPercentage(marginRates.OT, 0) : 'N/A';

  return {
    corporationName,
    agencyName,
    startDate,
    endDate,
    payRate,
    oTPayRate,
    billRate,
    oTBillRate,
    payMargin,
    oTPayMargin,
    stipend,
  };
};

/**
 * Checks if a contract is expired
 * @param {Object} contract - The contract object
 * @returns {boolean} True if contract is expired
 */
export const isContractExpired = (contract) =>
  contract?.timeWindow?.end && contract.timeWindow.end < Date.now();

/**
 * Gets the contract type display name
 * @param {string} contractType - The contract type from API
 * @returns {string} Display name for the contract type
 */
export const getContractTypeDisplayName = (contractType) => {
  const typeMap = {
    [CONTRACT_TYPES.RATE_OVERRIDE]: 'Rate Override',
    [CONTRACT_TYPES.MARGIN_OVERRIDE]: 'Margin Override',
  };
  return typeMap[contractType] || 'Unknown';
};

export default {
  transformContractData,
  isContractExpired,
  getContractTypeDisplayName,
};
